import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header, SectionLabel } from "../components/Brand";
import { api } from "../lib/api";
import { Loader2, ArrowRight, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("bh_admin_token", res.data.token);
      localStorage.setItem("bh_admin_email", res.data.email);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] text-white" data-testid="admin-login-page">
      <Header />
      <main className="max-w-md mx-auto px-6 py-20">
        <div className="flex items-center gap-2 mb-6">
          <Lock className="w-4 h-4 text-zinc-500" />
          <SectionLabel>Admin Login</SectionLabel>
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mb-8">
          Brandhero Admin Console
        </h1>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="bh-label">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              className="bh-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>
          <div>
            <label className="bh-label">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              className="bh-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="bh-btn-primary w-full justify-center"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Sign in
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </main>
    </div>
  );
}
